export function HorizontalBarRow({
  label,
  value,
  maxValue,
  formattedValue,
  subtitle,
  color = "rgb(var(--cyber-cyan))",
}: {
  label: string;
  value: number;
  maxValue: number;
  formattedValue: string;
  subtitle?: string;
  color?: string;
}) {
  const pct = maxValue > 0 ? Math.max((value / maxValue) * 100, 2) : 0;

  return (
    <div className="space-y-1">
      <div className="flex items-baseline justify-between gap-2">
        <div className="min-w-0 flex-1">
          <span className="block truncate text-xs text-cyber-text" title={label}>
            {label}
          </span>
          {subtitle && <span className="text-[10px] text-cyber-muted">{subtitle}</span>}
        </div>
        <span className="whitespace-nowrap text-xs text-cyber-muted">{formattedValue}</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-cyber-bg/80">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
}
